export var NOTIFICATIONS_REDUCER_NAME = '@notifications-reducer';
